
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginModalComponent } from 'src/app/common/login-modal/login-modal.component';
import { ModalsComponent } from 'src/app/common/modals/modals.component';
import { ScrollToTopComponent } from 'src/app/common/scroll-to-top/scroll-to-top.component';
import { ToastComponent } from 'src/app/common/toast/toast.component';
import { HeaderComponent } from 'src/app/pages/customer/common/header/header.component';
import { LoginModalService } from 'src/app/services/LoginModal/login-modal.service';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { FooterComponent } from '../../public/common/footer/footer.component';

@Component({
  selector: 'customer-template',
  imports: [
    HeaderComponent,
    RouterOutlet,
    ToastComponent,
    ModalsComponent,
    LoginModalComponent,
    FooterComponent,
    ScrollToTopComponent
],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss',
})
export class TemplateComponent {
  @ViewChild('toast', { static: true }) toastComponent!: ToastComponent;
  @ViewChild('modals', { static: true }) modalsComponent!: ModalsComponent;
  @ViewChild('login_modal', { static: true }) loginModalComponent!: LoginModalComponent;

  constructor(
    private toast: ToastService,
    private modal: ModalsService,
    private loginModal: LoginModalService
  ) {}

  ngOnInit() {
    this.toast.bindComponent(this.toastComponent);
    this.modal.bindComponent(this.modalsComponent);
    this.loginModal.bindComponent(this.loginModalComponent);
  }
}
